import { render, staticRenderFns } from "./PaymentConfirmationForm.vue?vue&type=template&id=6153b020"
import script from "./PaymentConfirmationForm.vue?vue&type=script&lang=ts"
export * from "./PaymentConfirmationForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports